<im-item-list
  [items]="items"
  [inspectionId]="inspectionId"
  [config]="config"
  [selectedItem]="selectedItem"
  [ngClass]="getItemListClass()"
  (selectedItemChanged)="onSelectedItemChanged($event)"
  (editedItem)="onEditedItem($event)"
  (editAction)="onEditAction()"
  (deletedItem)="onDeletedItem($event)"
  >
</im-item-list>

@if (selectedItem) {
  <im-item-form
    [item]="selectedItem"
    [inspectionId]="inspectionId"
    [isReadOnly]="config.isReadOnly"
    (goBackEvent)="onGoBackEvent()"
    >
  </im-item-form>
}
